import { render, staticRenderFns } from "./EventNameStep.vue?vue&type=template&id=438e8b60"
import script from "./EventNameStep.vue?vue&type=script&lang=js"
export * from "./EventNameStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports